
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  data: () => ({
    title: "Comment réussir ses cartes de visite avec des bonnes pratiques ?",
    description:
      "Découvrez comment réaliser des cartes de visite efficaces avec nos meilleures pratiques. De la conception au design, créez une carte qui marque les esprits.",
  }),

  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.description,
        },
        {
          hid: "og:title",
          property: "og:title",
          content: this.title,
        },
        {
          hid: "og:description",
          property: "og:description",
          content: this.description,
        },
      ],
    };
  },
};
